let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4HZlX")).then(() => parcelRequire('1w5AW'));